import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { BookDemoButton } from "@/pages/marketing/MarketingLayout";

const FAQS = [
  {
    q: "What does 'Human-approved' mean?",
    a: "Our core philosophy is that AI should assist, not replace. Every piece of AI-generated content enters an Approval Queue. It only publishes when an authorized team member clicks approve (or via a configurable auto-approve window).",
  },
  {
    q: "Who is 'Shee'?",
    a: "Shee is your AI Creative Director, powered by Claude. She converses with you to understand your goals and drafts tailored captions, images, and video ideas — and can even find or generate the right visuals for you.",
  },
  {
    q: "Is this a self-serve platform?",
    a: "Currently, we offer personalized onboarding to ensure PYC fits your business perfectly. Click 'Book a Demo' to get started — there's no public sign-up form.",
  },
  {
    q: "Which platforms can I publish to?",
    a: "Facebook, Instagram, LinkedIn, TikTok and YouTube, with direct API connections — no third-party scheduler in the middle.",
  },
  {
    q: "How long does onboarding take?",
    a: "Most teams are fully set up — brand profile, connected accounts, and first content in the Approval Queue — within a single onboarding session with our team.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="marketing-faq-page">
      <section className="max-w-3xl mx-auto px-6 pt-20 pb-8">
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tighter"
          style={{ fontFamily: "Outfit" }}
          data-testid="faq-page-title"
        >
          Frequently Asked Questions
        </motion.h1>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-10">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-slate-200 py-2" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                className="text-left text-base font-semibold text-slate-900 hover:no-underline tracking-tight"
                style={{ fontFamily: "Outfit" }}
                data-testid={`faq-question-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-24">
        <div className="rounded-3xl bg-slate-50 border border-slate-200 px-8 md:px-16 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight mb-3" style={{ fontFamily: "Outfit" }}>
              Still have questions?
            </h2>
            <p className="text-slate-600 max-w-md">Talk to us directly — we'll walk through your specific use case.</p>
          </div>
          <BookDemoButton testId="faq-cta-book-demo-button" />
        </div>
      </section>
    </div>
  );
}
